export const formatDateTimeLocal = (dateString: string): string => {
  return new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // remove AM/PM also set 24 hours format
  }).format(new Date(dateString));
};

/** A calendar date the API sends without a time ("YYYY-MM-DD"), as the same day in any time zone. */
export const formatCalendarDate = (dateString: string | null | undefined): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateString ?? '');
  return match ? `${match[3]}/${match[2]}/${match[1]}` : '';
};

export const formatDateToString = (date: Date | null, withTime = false): string => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  if (!withTime) {
    return `${year}-${month}-${day}`;
  }

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatApiDateToString = (dateString: string | null): string => {
  if (!dateString) return '';

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return '';

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const normalizeDate = (date: string | Date | null | undefined): string | null => {
  if (!date) return null;
  return new Date(date).toISOString();
};
